import axios from "axios";
import Config from "src/config";

// O formData precisa conter 'file' e 'canalId'
const v1_actionMessengerUploadMidia = (clienteId, formData) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/messenger/templates/upload-midia`,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

export default v1_actionMessengerUploadMidia;
